module.exports = __webpack_public_path__ + "ccc4714ca284f650224865a46cdfd1e3.png";


//////////////////
// WEBPACK FOOTER
// ./shared/images/header/water-tower-mobile.png
// module id = 977
// module chunks = 2